import { render, staticRenderFns } from "./SelectBankType.vue?vue&type=template&id=2fceb785"
import script from "./SelectBankType.vue?vue&type=script&lang=ts"
export * from "./SelectBankType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports